import { Col, FormGroup, Label, Row } from "reactstrap";
import CommonFileUpload from "../../../../../Utils/CommonComponents/CommonFileUpload";
import { UploadProjectFile } from "../../../../../Utils/Constants";

export default function UploadFile() {
  return (
    <Row>
      <Col>
        <FormGroup>
          <Label>{UploadProjectFile}</Label>
          <CommonFileUpload />
        </FormGroup>
      </Col>
    </Row>
  );
}
